import { ReactNode } from 'react';

import { PrivacyContextAwareMoneyValue } from '../PrivacyContextAwareMoneyValue';
import { DetailsListItem } from './DetailsListItem';
import { DetailsListLineItemTypography } from './DetailsListLineItemTypography';

export interface DetailsListLineItemProps {
  className?: string;
  value: number;
  children?: ReactNode;
}

/**
 * Items in the AccordionDetailsList that are not the final item and represent the "building blocks" that sum or combine
 * to get the final line item in the list.
 */
export const DetailsListLineItem = ({ children, className, value }: DetailsListLineItemProps) => {
  return (
    <DetailsListItem className={className}>
      <DetailsListLineItemTypography>{children}</DetailsListLineItemTypography>
      <DetailsListLineItemTypography fontWeight="bold">
        <PrivacyContextAwareMoneyValue value={value} length={4} />
      </DetailsListLineItemTypography>
    </DetailsListItem>
  );
};
